import React from 'react'

import styled from 'particles/themes/styled'
import { theme } from 'theme'
import { TableViewType } from 'components/Shared/MuiTable'
import { GridPinnedColumns } from '@mui/x-data-grid-pro'
import PartiTable from 'components/Shared/MuiTable/PartiTable'
import { useWindowHeight } from 'hooks'
import { GridColDef } from '@mui/x-data-grid-pro'

import styles from './styles'

interface RowState {
    id: string
    title: {
        isFirstTitle: boolean
        value: string
    }
}
interface RolesTableProps {
    className?: string
    isLoading: boolean
    rows: RowState[]
    columns: GridColDef[]
    pinnedColumns?: GridPinnedColumns
    hideFooter: boolean
    access: boolean
    hasFooterButtons: boolean
}

const RolesTable: React.FC<RolesTableProps> = ({
    className,
    isLoading,
    rows,
    columns,
    pinnedColumns,
    hideFooter,
    access,
    hasFooterButtons,
}) => {
    const windowHeight = useWindowHeight()

    return (
        <div className={className}>
            <PartiTable
                rowHeight={100}
                columns={columns}
                rows={rows}
                hideToolbar={true}
                enableExport={false}
                showFilter={false}
                showSearchBar={false}
                viewType={TableViewType.ROLE_MANAGEMENT}
                disableColumnMenu={true}
                hideFooterRowCount={true}
                displayPagination={false}
                isLoading={isLoading}
                tableHeight={
                    access || (windowHeight && windowHeight < 760) ? '66vh' : hasFooterButtons ? '78vh' : '83vh'
                }
                pinnedColumns={pinnedColumns}
                hideTableBorder
                noPadding
                hideFooter={hideFooter}
            />
        </div>
    )
}
export default styled(RolesTable)`
    ${styles}
    .Mui-hovered {
        background-color: ${theme.newColors.neutral100} !important;
    }
    ${({ rows }) =>
        rows.map((item: RowState) => {
            if (!item.title.isFirstTitle) return undefined
            return `
            [data-id = ${item.id}]{
                background-color:${theme.newColors.neutral100};
                    .MuiDataGrid-cell{
                        border:none;
                    }
                    .MuiData-cell:first-child{
                        border-right:1px inset ${theme.newColors.neutral200};
                    }

                    &:hover{
                         background-color:${theme.newColors.neutral200} !important
                    }
                }
            }`
        })}
`
